<div
  class="declaration-controls-item my-30 border-black vo-link-inside"
  *ngIf="
    declarationDto.Flags[referenceDataConstants.MarketingSection] ||
    declarationDto.Flags[referenceDataConstants.BrandMarketingSection]
  "
>
  <div class="declaration-item vo-panel-white p-30">
    <h3
      class="chapter-title vo-heading-regular-18 my-15"
      [innerHtml]="declarationDto.Labels[referenceDataLabels.MarketingConsent]"
    ></h3>

    <ng-container *ngIf="declarationDto.Flags[referenceDataConstants.MarketingSection]">
      <div
        class="vo-body-regular-14"
        [innerHtml]="declarationDto.Labels[referenceDataLabels.MarketingConsentContentPart1]"
      ></div>

      <div class="preferences-container bold-checkbox d-flex flex-wrap vo-panel-grey my-30 mx--30 px-15">
        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.MarketingTel]"
          [controlId]="referenceDataLabels.Telephone"
          [checkboxLabel]="referenceDataLabels.Telephone | localizeLabel"
          [(value)]="mortgageApplication.Consent.ContactByTelephone"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.MarketingSMS]"
          [controlId]="referenceDataLabels.SMS"
          [checkboxLabel]="referenceDataLabels.SMS | localizeLabel"
          [(value)]="mortgageApplication.Consent.ContactBySms"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.MarketingEmail]"
          [controlId]="referenceDataLabels.Email"
          [checkboxLabel]="referenceDataLabels.Email | localizeLabel"
          [(value)]="mortgageApplication.Consent.ContactByEmail"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.MarketingPost]"
          [controlId]="referenceDataLabels.Post"
          [checkboxLabel]="referenceDataLabels.Post | localizeLabel"
          [(value)]="mortgageApplication.Consent.ContactByPost"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>
      </div>
      <div
        class="vo-body-regular-14"
        [innerHtml]="declarationDto.Labels[referenceDataLabels.MarketingConsentContentPart2]"
      ></div>
    </ng-container>

    <ng-container *ngIf="declarationDto.Flags[referenceDataConstants.BrandMarketingSection]">
      <div
        class="vo-body-regular-14"
        [innerHtml]="declarationDto.Labels[referenceDataLabels.BrandMarketingConsentContentPart1]"
      ></div>

      <div class="preferences-container bold-checkbox d-flex flex-wrap vo-panel-grey my-30 mx--30 px-15">
        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.BrandMarketingTel]"
          [controlId]="'TelephoneBrand'"
          [checkboxLabel]="referenceDataLabels.Telephone | localizeLabel"
          [(value)]="mortgageApplication.BrandConsent.ContactByTelephone"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.BrandMarketingSMS]"
          [controlId]="'SMSBrand'"
          [checkboxLabel]="referenceDataLabels.SMS | localizeLabel"
          [(value)]="mortgageApplication.BrandConsent.ContactBySms"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.BrandMarketingEmail]"
          [controlId]="'EmailBrand'"
          [checkboxLabel]="referenceDataLabels.Email | localizeLabel"
          [(value)]="mortgageApplication.BrandConsent.ContactByEmail"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>

        <boi-form-checkbox
          class="w-50"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          *ngIf="declarationDto.Flags[referenceDataConstants.BrandMarketingPost]"
          [controlId]="'PostBrand'"
          [checkboxLabel]="referenceDataLabels.Post | localizeLabel"
          [(value)]="mortgageApplication.BrandConsent.ContactByPost"
          [trueValue]="true"
          [falseValue]="undefined"
        >
        </boi-form-checkbox>
      </div>

      <div
        class="vo-body-regular-14"
        [innerHtml]="declarationDto.Labels[referenceDataLabels.BrandMarketingConsentContentPart2]"
      ></div>
    </ng-container>
  </div>
</div>
